export var compareReadyEvents=function(e,a){return e.isReady===a.isReady};